import ApiClient from './ApiClient'

class SummaryService {
  static getFormOptions(collectId) {
    return ApiClient.get(`/collects/${collectId}/summaries/new.json`)
  }

  static getSummary(collectId, summaryId) {
    return ApiClient.get(`/collects/${collectId}/summaries/${summaryId}.json`)
  }

  static createSummary(collectId, data) {
    return ApiClient.post(`/collects/${collectId}/summaries.json`, { summary: data })
  }

  static updateSummary(collectId, summaryId, data) {
    return ApiClient.put(`/collects/${collectId}/summaries/${summaryId}.json`, { summary: data })
  }
}

export default SummaryService
